import React, { useEffect, useState } from "react";
import { useDispatch, useStore } from "react-redux";
import { setAccessToken } from "../redux/slices/authSlice";
import { loginInfo } from "../redux/slices/loginSlice";
import { loginAPI } from "../api";

export default function AuthBootstrap({ children }) {
  const dispatch = useDispatch();
  const store = useStore();
  const [ready, setReady] = useState(() =>
    Boolean(store.getState().authReducer?.accessToken)
  );

  useEffect(() => {
    if (store.getState().authReducer?.accessToken) return;

    let cancelled = false;

    (async () => {
      try {
        const r = await loginAPI.refresh();
        if (cancelled) return;

        const accessToken = r?.data?.access_token;
        if (!accessToken) return;

        dispatch(setAccessToken(accessToken));

        try {
          const me = await loginAPI.me();
          if (cancelled) return;
          const user = me?.data?.user_info ?? me?.data;
          if (user) dispatch(loginInfo(user));
        } catch {
          // user info fetch failed — keep token, user must re-login from a guarded page
        }
      } catch {
        // no valid refresh cookie — stay logged out
      } finally {
        if (!cancelled) setReady(true);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [dispatch, store]);

  if (!ready) return null;
  return children;
}
